var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show_all)?_c('all-customers'):_vm._e(),(_vm.show_create)?_c('create-customer'):_vm._e(),(_vm.show_edit)?_c('edit-customer',{attrs:{"customer":_vm.customer}}):_vm._e(),_c('inactivity-logout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }